const { Buffer } = require('buffer');

const VerifyPDFError = require('../VerifyPDFError');
const { getSignatureMeta, preparePDF } = require('./general');

const DEFAULT_BYTE_RANGE_PLACEHOLDER = '**********';

const getByteRange = (pdfBuffer) => {
    const byteRangeStrings = pdfBuffer.toString().match(/\/ByteRange\s*\[{1}\s*(?:(?:\d*|\/\*{10})\s+){3}(?:\d+|\/\*{10}){1}\s*\]{1}/g);
    if (!byteRangeStrings) {
        throw new VerifyPDFError(
            'Failed to locate ByteRange.',
            VerifyPDFError.TYPE_PARSE,
        );
    }
    //console.log(byteRangeStrings);
    const byteRangePlaceholder = byteRangeStrings.find((s) => s.includes(`/${DEFAULT_BYTE_RANGE_PLACEHOLDER}`));
    const byteRanges = byteRangeStrings.map((brs) => brs.match(/[^[\s]*(?:\d|\/\*{10})/g));

    const byteRange = byteRanges[0].map(Number);

    return {
        byteRangePlaceholder,
        byteRange,
    };
};

const extractSignature = (pdf) => {
    const pdfBuffer = preparePDF(pdf);
    //console.log(pdfBuffer);
    const { byteRange } = getByteRange(pdfBuffer);
    const endOfByteRange = byteRange[2] + byteRange[3];
    //console.log(byteRange);
    const signedData = Buffer.concat([
        pdfBuffer.slice(byteRange[0], byteRange[1]),
        pdfBuffer.slice(
            byteRange[2],
            byteRange[2] + byteRange[3]
        ),
    ]);

    if (pdfBuffer.length > endOfByteRange) {

        if (pdfBuffer.slice(endOfByteRange-6,endOfByteRange).toString() !== '%%EOF\n') {
            throw new VerifyPDFError(
                'Failed byte range verification.',
                VerifyPDFError.VERIFY_BYTE_RANGE,
            );
        }

    }

    const signatureHexWithBuffer = pdfBuffer
        .slice(byteRange[1] + 1, byteRange[2] - 1)
        .toString("binary");

    const signatureHex = signatureHexWithBuffer.replace(/(?:00)*$/, "");
    const signature = Buffer.from(signatureHex, "hex").toString("binary");

    //const signatureHex = pdfBuffer.slice(byteRange[0] + byteRange[1] + 1, byteRange[2]).toString('binary');
    //console.log(signatureHex);
    //const signature = Buffer.from(signatureHex, 'hex').toString('binary');
    //console.log(signature);
    return {
        byteRange,
        signature,
        signedData,
        signatureMeta: getSignatureMeta(signedData),
    };
};

module.exports = extractSignature;
